import React, { useEffect, useState } from "react";

import Head from "next/head";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { createUseStyles } from "react-jss";

import UrlErrorImage from "../../common/UrlErrorImage";
import { getCountry } from "../../../common/userfuctions";
import Sidebar from "../../Sidebar";

const Header = dynamic(() => import("../../Header.js"));
const Footer = dynamic(() => import("../../Footer.js"));

const MainLayout = ({ children, title, description, image, status }) => {

  const [locationModal, setLocationModal] = useState(false);
  const [country, setCountry] = useState("");

  const router = useRouter();

  const styles = useStyles();
  const employerLayout = router.asPath.includes("/employer")
  useEffect(() => {
    
    const userCountry = getCountry();

    if (userCountry) {
      setCountry(userCountry);
      setLocationModal(false);
    } else {
      setLocationModal(true);
    }
  }, [country]);

 
  return (
    <>
      <Head>
        <title>{title ? title : "HireSide by WebHR"}</title>
        <meta charSet="utf-8" />
        <meta name="author" content="HireSide" />
        <meta name="theme-color" content="#fff" />
        <meta name="custom1" content="hireside_www" />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="viewport" content="width=device-width" />
        <meta httpEquiv="X-UA-Compatible" content="ie=edge" />
        <meta name="description" content={description ? description : ""} />
        <meta
          property="og:title"
          content={title ? title : "HireSide by WebHR"}
        ></meta>
        <meta
          property="og:description"
          content={description ? description : "HireSide by WebHR"}
        ></meta>
        <meta
          property="og:image"
          content={image ? image : "https://hireside.com/url_logo.png"}
        ></meta>
        <meta
          name="copyright"
          content="© 2022 - HireSide Inc. Developed by Verge Inc."
        />
      </Head>
      <div className={styles.main}>
      { employerLayout ? <Sidebar/> :  <Header />}
       <main style={{ paddingTop: employerLayout ? '0px' : '70px' }}>
        {status === 1 ? (
          children
        ) : status === undefined ? (
          children
        ) : (
          <UrlErrorImage />
        )}
        </main>
      </div>
      <Footer />
    </>
  );
};

const useStyles = createUseStyles({
  main: {    
    display: "flex",
    height: "100vh",
    overflow: "auto",
    flexDirection: "column",
  },
  blurDiv: {
    height: "100%",
    background: "#ffffff",
    position: "absolute",
    filter: `blur(400px)`,
    width: "100%",
    zIndex: 1,
  },
});

export default dynamic(() => Promise.resolve(MainLayout), { ssr: false })

